export enum PaymentRequestTypeEnum {
    Deposits = 2,
    Withdrawals = 1,
    DepositAndWithdrawals = 3,
}
